var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"boardWrap",staticClass:"absolute top-0 bottom-0 right-0 left-0"},[_c('canvas',{ref:"board",style:({ marginTop: _vm.marginTop + 'px'})})])}
var staticRenderFns = []

export { render, staticRenderFns }